/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'

type Props = {
  className?: string
  bgColor?: string
  title?: string
  title2?: string
  link?: string
}
const TilesWidget3 = ({
  className,
  bgColor = '#663259',
  title = 'My Profile Overview',
  title2 = 'MDSD',
  link = '/schedules?arrIcao=MDSD',
}: Props) => {
  return (
    <div
      className={clsx('card h-100 bgi-no-repeat bgi-size-cover', className)}
      style={{
        backgroundImage: `linear-gradient(90deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.4) 100%),url("${toAbsoluteUrl(
          '/media/misc/feat-2.jpg'
        )}")`,
        backgroundPosition: 'left center',
      }}
    >
      {/* begin::Body */}
      <div className='card-body d-flex flex-column justify-content-between'>
        {/* begin::Title */}
        <div className='text-white fw-bold fs-2'>
          <h2 className='fw-bold text-white mb-2'>{title}</h2>
          <a className='text-white' href={title2?.length === 4 ? '/airport/' + title2 : link}>
            {title2}
          </a>
        </div>
        {/* end::Title */}

        {/* begin::Link */}
        <a href={link} className='text-danger fw-semibold'>
          View details
          <KTSVG
            className='svg-icon-2 svg-icon-danger'
            path='/media/icons/duotune/arrows/arr064.svg'
          />
        </a>
        {/* end::Link */}
      </div>
      {/* end::Body */}
    </div>
  )
}

export {TilesWidget3}
